import { VARIABLE_CONSTANTS, VariableCrudManagerService } from "@wms/variables";
import { ServiceFactoryService } from "@wms/services";
import { forEach, groupBy, includes, reject } from "lodash-es";
import { BaseComponent } from "@wms/app/components";
import { BaseVariableService } from "@wms/variables";
export class OpenapiVariableCreation extends BaseComponent {
    constructor(private serviceFactory: ServiceFactoryService, private varManagerService: VariableCrudManagerService, private variableService: BaseVariableService) {
        super();
    }
    /*
    * gets the data-services required for selecting live-source for a live variable
    * called on switching to a new/created live variable
    */
    getVariableDependencies() {
        this.initApiTypeOptions();
        /*get the list of services available and append the options for service property*/
        (this.serviceFactory.getServicesWithType() as Promise<any>).then((services: any) => {
            services = reject(services, (service) => !includes(VARIABLE_CONSTANTS.OPEN_API_VARIABLE_SERVICE, service.type));
            services.sort((prevItem: any, currentItem: any) => prevItem.name.localeCompare(currentItem.name));

            /*push the services in the options list for the respective property selectbox*/
            this.varManagerService.initVariableObj.propertyObj.service.options = {};
            forEach(services, (serviceObj) => {
                this.varManagerService.initVariableObj.propertyObj.service.options[serviceObj.name] = {
                    name: serviceObj.name,
                    type: 'Imported APIs'
                };
            });
        });
    }

    getApiOptions() {
        return {
            'Open API': [{
                id: VARIABLE_CONSTANTS.SERVICE_TYPE_OPEN_API,
                'name': 'Imported APIs'
            }]
        };
    }

    initApiTypeOptions() {
        let options = this.getApiOptions(),
            apiTypeOptions: any = {};
        forEach(options, (options, key) => {
            options.forEach((option) => {
                apiTypeOptions[option.id] = { name: option.name, type: key, id: option.id };
            });
        });
        this.varManagerService.initVariableObj.propertyObj.apitype.options = apiTypeOptions;
    }

    onServiceChange() {
        let source: any = this.varManagerService.initVariableObj.values.service;
        if (source) {
            (this.serviceFactory.getServiceOperations(source) as Promise<any>).then((operations) => {
                let crudOperations = operations.filter((op: any) => {
                    return op.entityName && op.operationType;
                });
                let entities = groupBy(crudOperations, 'entityName');
                let obj: any = {};
                forEach(Object.keys(entities), (val) => {
                    obj[val] = val;
                });
                this.varManagerService.entities = entities;
                this.varManagerService.initVariableObj.propertyObj.entity.options = obj;
            });
        } else {
            this.hideFieldsOnChange('sourceCleared');
        }
    }

    hideFieldsOnChange(changedElement: any) {
        let propertyObj = this.varManagerService.initVariableObj.propertyObj;
        switch(changedElement) {
            case 'sourceCleared':
                propertyObj.target.hide = true;
                propertyObj.entity.hide = true;
                if(this.varManagerService.initVariableObj.values) {
                    this.varManagerService.initVariableObj.values.target = undefined;
                    this.varManagerService.initVariableObj.values.entity = undefined;
                }
                if(propertyObj.entity.options) {
                    propertyObj.entity.options = undefined;
                    this.varManagerService.entities = {};
                }
                break;
        }
    }

    __onPropertyChange(propName: any, newVal?: any) {
        let selectedService = this.varManagerService.initVariableObj.values.service;
        switch (propName) {
            case 'service':
                this.varManagerService.initVariableObj.propertyObj.target.hide = false;
                if (this.projectService.isNativeMobileApplicationType()) {
                    this.varManagerService.initVariableObj.propertyObj.target.modelObj.target = "other";
                    this.__onPropertyChange('target');
                }
                this.onServiceChange();
                break;
            case 'target':
                this.variableService.selectedVariable = undefined;
                this.varManagerService.initVariableObj.values.entity = undefined;
                if (this.varManagerService.initVariableObj.values.target === 'entities') {
                    this.varManagerService.initVariableObj.propertyObj.entity.hide = false;
                    if (this.variableService.selectedVariable && this.variableService.selectedVariable.propertyObj && this.variableService.selectedVariable.propertyObj.operation) {
                        this.variableService.selectedVariable.propertyObj.operation.hide = true;
                    }
                } else {
                    this.varManagerService.initVariableObj.propertyObj.entity.hide = true;
                    this.varManagerService.selectedVariableCategory = 'wm.ServiceVariable';
                    this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
                        service: selectedService,
                        operation: undefined
                    });
                    this.varManagerService.showPrimaryProps = true;
                }
                break;
            case 'entity':
                let operation = this.varManagerService.initVariableObj.values.entity;
                if (operation) {
                    this.varManagerService.selectedVariableCategory = 'wm.CrudVariable';
                    var entity = this.varManagerService.entities[this.varManagerService.initVariableObj.values.entity];
                    var crudOperationId = entity ? entity[0].crudOperationId : '';
                    this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
                        service: selectedService,
                        operation: operation.replace(/Controller$/, ''),
                        crudOperationId: crudOperationId,
                        operationId: operation.replace(/Controller$/, ''),
                        operationType: 'list'
                    });
                }
                else {
                    if(this.variableService.selectedVariable) {
                        this.variableService.selectedVariable = undefined;
                    }
                }
                this.varManagerService.showPrimaryProps = true;
                break;
        }
    }


}
